<template>
  <div class='SubLinkNave' @click="push">
    {{ data.name }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SubLinkNave',
  props: ['data'],
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts', 'Loading']),
    async push () {
      this.Loading(true)
      this.$router.push(`/loja/${this.data.link}`)
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
            .then(() => this.Loading(false))
        })
    }
  }
}
</script>

<style scoped>
.SubLinkNave {
  text-align: left;
  padding: 5%;
  cursor: pointer;
  color: #000000;
}

.SubLinkNave:hover {
  background-color: #CCCCCC;
}
</style>
